import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useMediaQuery } from "react-responsive";
import { useNavigate } from 'react-router-dom';
import chatApi from '../../api/chatApi';
import advancedDataApi from '../../api/advancedDataApi';
import authApi from '../../api/authApi';
import './ChatApp.css';
import { useSocket } from './useSocket';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsBindPay, selectUserEmail, selectUserId, setIsStart } from '../Login/loginSlice';
import { selectDialogId, selectIsAwaitingRole, selectMessages, selectRatingMessageId, setDialogId, setMessages, setRatingMessageId, setIsAwaitingRole, selectSelectedSubOption, selectInput, setInput, selectMode, setMode, selectDialogs, setDialogs, selectIsWaiting, setIsWaiting, setDialogName, selectIsWebSearch, selectIsStorageUse } from './chatSlice';
import Sidebar from '../Sidebar/Sidebar';
import { RxCross2 } from "react-icons/rx";

import { useHeaderLogic } from '../../hooks/useHeaderLogic';

import Tokens from './Tokens';
import ChatContainer from '../ChatContainer/ChatContainer';
import profilApi from '../../api/profilApi';
import AssistantConfigModal from '../Provider/AssistantConfig';
import VoiceAgent from './VoiceAssistantConfig'
import ChatCategories from '../ChatCategories/ChatCategories';
import AddPanel from '../AddPanel/AddPanel';
import { IoArrowUpCircleOutline } from 'react-icons/io5';
import { BsArrowUpCircle, BsMic, BsMicFill } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import DeviceLimitModal from '../DeviceComponent/DeviceLimitModal';

const ChatApp = () => {
    const [chatType, setChatType] = useState('quick');
    const userId = useSelector(selectUserId);
    const auth = { userId };
    const { socket } = useSocket(auth);
    const navigate = useNavigate();
    const [files, setFiles] = useState([]);
    // const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false); //todo
    const [message, setMessage] = useState('');
    // const [dialogs, setDialogs] = useState([]);
    const [rating, setRating] = useState(null);
    const [userDetails, setUserDetails] = useState({ name: '', inn: '' })

    // const [isAwaitingRole, setIsAwaitingRole] = useState(false);
    const [role, setRole] = useState('');
    const [isAwaitingDetails, setIsAwaitingDetails] = useState(false);
    const [isAwaitingQuestion, setIsAwaitingQuestion] = useState(false);
    const [isAwaitingRateComment, setIsAwaitingRateComment] = useState(false);
    const [isAnalysisComplete, setIsAnalysisComplete] = useState(false);
    // const [question, setQuestion] = useState('');
    const [progress, setProgress] = useState(0);

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" }); // Мобильное устройство
    const isDesktop = useMediaQuery({ query: "(min-width: 769px)" });
    const isBindPay = useSelector(selectIsBindPay)
    const isWaiting = useSelector(selectIsWaiting)
    const isWebSearch = useSelector(selectIsWebSearch)
    const [isSubscription, setIsSubscription] = useState(false)
    // const [isTest, setIsTest] = useState(false);
    const [isVoiceAssiatant, setIsVoiceAssistant] = useState(false)
    const [isHelped, setIsHelped] = useState(false)
    const [isVoiceActive, setIsVoiceActive] = useState(false);
    const [form, setForm] = useState({
        name: '',
        description: '',
    });
    const [advanceReportForm, setAdvanceReportForm] = useState({
        organizationName: '',
        headPosition: '',
        headFullName: '',
        accountablePerson: '',
        accountablePersonPosition: '',
        chiefAccountantFullName: '',
        accountantFullName: '',
        cashierFullName: '',
    });
    const [advanceReportSaved, setAdvanceReportSaved] = useState(false);
    const [showDeviceLimit, setShowDeviceLimit] = useState(false);
    const [docsEditStatus, setDocsEditStatus] = useState('idle');
    const [testLimitState, setTestLimitState] = useState({
        isTestSubscription: false,
        allowed: true,
        reason: null,
        message: null,
        used: 0,
        remaining: 0,
        limit: 5,
    });




    const [voiceUsage, setVoiceUsage] = useState({
        limitMs: 0,
        usedMs: 0,
        remainingMs: 0,
        warn30: false,
        warn5: false,
        expired: false,
        // isAllowed: false,
    });


    const [toast, setToast] = useState(null);

    function showToast(message, type = "info") {
        setToast({ message, type });
        setTimeout(() => setToast(null), 4000);
    }

    const mode = useSelector(selectMode)
    const userEmail = useSelector(selectUserEmail)
    const dialogId = useSelector(selectDialogId)
    const isStorageUse = useSelector(selectIsStorageUse)

    const messages = useSelector(selectMessages)
    const dialogs = useSelector(selectDialogs)
    const ratingMessageId = useSelector(selectRatingMessageId)
    const isAwaitingRole = useSelector(selectIsAwaitingRole)
    const selectedSubOption = useSelector(selectSelectedSubOption)
    const input = useSelector(selectInput);
    const textareaRef = useRef(null);
    const fileInputRef = useRef(null);

    const clearSelectedFiles = useCallback(() => {
        setFiles([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, []);

    const trackDocsEvent = useCallback((eventName, payload = {}) => {
        window.dispatchEvent(new CustomEvent('docs-edit-analytics', {
            detail: { event: eventName, ...payload }
        }));
    }, []);

    const isSocketAckSuccess = useCallback((ack) => {
        return Boolean(ack && (ack.success === true || ack.status === 'ok'));
    }, []);

    const isDocsEditFile = useCallback((file) => {
        if (!file?.name) return false;
        const lowerName = file.name.toLowerCase();
        return lowerName.endsWith('.docx') || lowerName.endsWith('.xlsx');
    }, []);

    const extractAdvanceReportPayload = useCallback((rawText) => {
        const fieldMap = {
            1: 'organizationName',
            2: 'headPosition',
            3: 'headFullName',
            4: 'accountablePerson',
            5: 'accountablePersonPosition',
            6: 'chiefAccountantFullName',
            7: 'accountantFullName',
            8: 'cashierFullName',
        };

        const source = String(rawText || '')
            .replace(/\r/g, '\n')
            .replace(/([^\n])\s+(?=[1-8]\s*[)\.:-])/g, '$1\n');

        const lines = source
            .split('\n')
            .map((line) => line.trim())
            .filter(Boolean);

        const values = {};
        let currentNumber = null;

        for (const line of lines) {
            if (/^\d+\s*:\s*$/.test(line)) {
                continue;
            }

            const match = line.match(/^([1-8])\s*[)\.:-]\s*(.+)$/);
            if (match) {
                currentNumber = Number(match[1]);
                values[currentNumber] = match[2].trim();
                continue;
            }

            if (currentNumber && values[currentNumber]) {
                values[currentNumber] = `${values[currentNumber]} ${line}`.trim();
            }
        }

        const missingNumbers = Object.keys(fieldMap)
            .map(Number)
            .filter((number) => !values[number] || !String(values[number]).trim());

        if (missingNumbers.length > 0) {
            return {
                payload: null,
                missingNumbers,
            };
        }

        return {
            payload: {
                userId,
                organizationName: values[1],
                headPosition: values[2],
                headFullName: values[3],
                accountablePerson: values[4],
                accountablePersonPosition: values[5],
                chiefAccountantFullName: values[6],
                accountantFullName: values[7],
                cashierFullName: values[8],
            },
            missingNumbers: [],
        };
    }, [userId]);

    const normalizeEditedFileMeta = useCallback((raw) => {
        if (!raw) return null;
        return {
            sessionId: raw.sessionId || raw.session_id || '',
            version: Number(raw.version || 1),
            originalFileUrl: raw.originalFileUrl || raw.original_file_url || '',
            editedFileUrl: raw.editedFileUrl || raw.edited_file_url || '',
            createdAt: raw.createdAt || raw.created_at || '',
        };
    }, []);

    const getLatestDocsEditMeta = useCallback(() => {
        for (let i = messages.length - 1; i >= 0; i -= 1) {
            const messageItem = messages[i];
            const editedFiles = Array.isArray(messageItem?.editedFiles) ? messageItem.editedFiles : [];
            if (editedFiles.length > 0) {
                const meta = normalizeEditedFileMeta(editedFiles[0]);
                if (meta) {
                    return {
                        meta,
                        messageId: messageItem.id,
                    };
                }
            }
        }

        return null;
    }, [messages, normalizeEditedFileMeta]);

    const looksLikeDocumentEditIntent = useCallback((rawText) => {
        const value = String(rawText || '').trim().toLowerCase();
        if (!value) return false;

        return /(\u043a\u043e\u0440\u0440\u0435\u043a\u0442|\u0438\u0441\u043f\u0440\u0430\u0432|\u0440\u0435\u0434\u0430\u043a\u0442|\u043f\u0440\u0430\u0432\u043a|\u0434\u043e\u0440\u0430\u0431\u043e\u0442|\u043f\u0435\u0440\u0435\u0440\u0430\u0431\u043e\u0442|\u0438\u0437\u043c\u0435\u043d\u0438|\u0438\u0437\u043c\u0435\u043d\u0438\u0442\u044c|\u0432\u043d\u0435\u0441\u0438|\u0434\u043e\u0431\u0430\u0432\u044c|\u0443\u0434\u0430\u043b\u0438|\u0437\u0430\u043c\u0435\u043d\u0438|\u043f\u043e\u043c\u0435\u043d\u044f\u0439|edit|revise|revision|amend|change|update)/i.test(value);
    }, []);

    const resolveDocsEditSessionId = useCallback(async () => {
        const latest = getLatestDocsEditMeta();
        if (!latest) return null;

        if (latest.meta?.sessionId) {
            return latest.meta.sessionId;
        }

        if (!latest.messageId || !userId) {
            return null;
        }

        try {
            const response = await chatApi.getSession(userId, latest.messageId);
            return response?.data?.session_id || response?.data?.sessionId || null;
        } catch (error) {
            trackDocsEvent('docs_edit_error', {
                code: error?.response?.status || 'network',
                action: 'get-session'
            });
            return null;
        }
    }, [getLatestDocsEditMeta, userId, trackDocsEvent]);

    const warned30Ref = useRef(false);
    const warned5Ref = useRef(false);

    // Speech-to-text (голосовой ввод)
    const [isRecordingSpeech, setIsRecordingSpeech] = useState(false);

    const speechBaseInputRef = useRef('');
    const speechTranscriptRef = useRef('');
    const webSpeechInterimRef = useRef('');
    const webSpeechRef = useRef(null);
    const speechSilenceTimeoutRef = useRef(null);
    const speechStopTimerRef = useRef(null);
    const restartTimeoutRef = useRef(null);
    const isSpeechRecordingRef = useRef(false);
    const lastFinalChunkRef = useRef('');
    const isManuallyStoppingRef = useRef(false);
    const restartAttemptsRef = useRef(0);
    const maxRecordingTimerRef = useRef(null);
    const micStreamRef = useRef(null);


    // const canUseVoice =
    //     isVoiceAssiatant &&
    //     input.trim() === '' &&
    //     !isWaiting &&
    //     files.length === 0;

    // Показываем кнопку голосового ассистента если:
    // - нет текста в поле ввода ИЛИ голосовой ассистент уже активен
    // - не ждём ответа
    // - нет файлов
    // - лимит не исчерпан
    const inputText = typeof input === 'string' ? input : '';
    const canUseVoice =
        (inputText.trim() === '' || isVoiceActive) &&
        !isWaiting &&
        files.length === 0 &&
        !voiceUsage.expired;

    // Показываем кнопку отправки когда есть текст
    const showSendButton = inputText.trim() !== '';



    const dispatch = useDispatch();

    const { checkSubscription, logout } = useHeaderLogic();

    useEffect(() => {
        checkSubscription(userEmail, (v) => dispatch(setIsStart(v)));
    }, [userEmail]);

    const reloadDialogs = async () => {
        try {
            const res = await chatApi.getUserDialogs(userId);
            const res_dialogs = res.data.dialogs;
            dispatch(setDialogs(res_dialogs));
            return res_dialogs;
        } catch (error) {
            console.error("Ошибка при загрузке диалогов:", error.message);
            return [];
        }
    };


    const fetchDialogs = async () => {
        ////console.log('fetchDialogs')
        try {
            const res_dialogs = await reloadDialogs()
            ////console.log('res_dialogs', res_dialogs)
            if (res_dialogs.length === 0 && !!userId && false) { // todo
                const res = await chatApi.startNewDialog(userId);
                dispatch(setDialogId(res.data.dialogId))
                const dialogId = res.data.dialogId
                socket.emit('joinDialog', { dialogId });
                localStorage.setItem(`lastDialogId_${userId}`, res.data.dialogId);
                fetchDialogs();
                dispatch(setMode('chat'))
                return
            }
            const lastDialogId = localStorage.getItem(`lastDialogId_${userId}`);
            const lastDialogName = localStorage.getItem(`lastDialogName_${userId}`);
            // ////console.log('lastDialogId', lastDialogId, dialogId);

            if (lastDialogId && dialogId === null) {
                // ////console.log('test 1');
                dispatch(setDialogId(lastDialogId));
                dispatch(setDialogName(lastDialogName));
                // await fetchMessages(lastDialogId);
                await initAndJoin(lastDialogId);
                handleSelectDialog(lastDialogId);
            }
            else if (dialogId === null && res_dialogs.length > 0) {
                // ////console.log('test 2');
                const newDialogId = res_dialogs[0].id;
                const newDialogName = res_dialogs[0].name;
                dispatch(setDialogId(newDialogId));
                dispatch(setDialogName(newDialogName));
                // await fetchMessages(newDialogId);
                await initAndJoin(newDialogId);
                handleSelectDialog(newDialogId);
            }
            // dispatch(setMode('chat'))

        } catch (err) {
            console.error('Ошибка загрузки диалогов:', err);
        }
    };

    const handlePaymentSuccess = async () => {
        try {
            const newDialog = await chatApi.startNewDialogBeginning(userId);
            const newDialogId = newDialog.data.dialogId
            fetchDialogs();
            dispatch(setMode('chat'))
            localStorage.setItem("dialogId", newDialogId);

            const selectedDialog = dialogs.find(dialog => dialog.id === newDialogId);

            dispatch(setDialogName(selectedDialog ? selectedDialog.name : ''));
            dispatch(setDialogId(newDialogId))

            navigate("/chat");
        } catch (err) {
            console.error("Ошибка при создании нового диалога:", err);
        }
    };


    const fetchMessages = async (dialogId) => {
        try {
            // ////console.log('dialogId while sending', dialogId);
            if (!userId || !dialogId) return
            const res = await chatApi.fetchMessages(userId, dialogId);
            // ////console.log('res.data', res.data);
            setLoading(false);

            dispatch(setMessages(res.data.messages));
            dispatch(setRatingMessageId(null));

            localStorage.setItem(`lastDialogId_${userId}`, res.data.dialogId);
        } catch (err) {
            console.error('Ошибка загрузки сообщений:', err);
        }
    };



    // socket.on('error', (error) => {
    //     console.error('Ошибка:', error.message);
    //     alert(error.message);
    // })

    function getSimpleDeviceId() {
        const screenResolution = window.screen ? `${window.screen.width}x${window.screen.height}` : 'unknown';
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const language = navigator.language;
        const platform = navigator.platform;
        ////console.log('platform', navigator)

        const rawId = `${screenResolution}-${timezone}-${language}-${platform}`;

        // Создаём хеш (простой через встроенный TextEncoder и crypto API)
        const encoder = new TextEncoder();
        const data = encoder.encode(rawId);

        return crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
            return hashHex;
        });
    }

    const handleSendMessage = async () => {
        if (isSpeechRecordingRef.current) {
            stopSpeechRecording();
        }
        if (!isSubscription) {
            showToast(testLimitState?.message || 'На Вашем балансе недостаточно средств, приобретите, пожалуйста, подписку.', 'error');
            return;
        }

        if (testLimitState?.isTestSubscription) {
            try {
                const usageRes = await profilApi.getTestLimit(userId, userEmail);
                const usage = usageRes?.data || {};
                setTestLimitState({
                    isTestSubscription: Boolean(usage.isTestSubscription),
                    allowed: Boolean(usage.allowed),
                    reason: usage.reason || null,
                    message: usage.message || null,
                    used: Number(usage.used || 0),
                    remaining: Number(usage.remaining || 0),
                    limit: Number(usage.limit || 5),
                });

                if (!usage.allowed) {
                    setIsSubscription(false);
                    showToast(usage.message || 'Лимит тестовой подписки исчерпан', 'error');
                    return;
                }
            } catch (error) {
                console.error('Ошибка проверки test-limit перед отправкой:', error);
                showToast('Не удалось проверить лимит тестовой подписки. Повторите позже', 'error');
                return;
            }
        }
        setProgress(0)
        // ////console.log('handleSendMessage', dialogId)
        let newDialogId = dialogId
        if (dialogId === 'null' || !dialogId) {
            try {
                const res = await chatApi.startNewDialog(userId);
                dispatch(setDialogId(res.data.dialogId))
                newDialogId = res.data.dialogId
                if (!socket) {
                    console.warn('Socket not ready — cannot join new dialog', newDialogId);
                } else if (!socket.connected) {
                    console.warn('Socket not connected — joinDialog skipped', newDialogId);
                } else {
                    socket.emit('joinDialog', { dialogId: newDialogId }, (ack) => {
                        if (!isSocketAckSuccess(ack)) console.warn('joinDialog ack:', ack);
                    });
                }
                localStorage.setItem(`lastDialogId_${userId}`, res.data.dialogId);
                dispatch(setMessages([]))
                dispatch(setRatingMessageId(null))
                dispatch(setMode('chat'))
                fetchDialogs();
            } catch (err) {
                console.error('Ошибка создания нового диалога:', err);
            }

            // alert('ВЫберите диалог или создайте')
            // return;

        }

        if (isAwaitingDetails) {
            const [name, inn] = input.split(', ');
            setUserDetails({ name, inn });
            setIsAwaitingDetails(false);
            setIsAwaitingQuestion(true);
            dispatch(setInput(''))
            return;
        }

        if (isAwaitingQuestion) {
            try {
                await handleSendMessageToLawyer();
            } catch (err) {
                console.error('Ошибка отправки сообщения юристу:', err);
            } finally {
                return;
            }
        }

        if (isAwaitingRateComment) {
            if (!inputText.trim()) return
            setRatingMessage(inputText.trim())
            dispatch(setInput(''))
            setIsAwaitingRateComment(false);
            newSystemMessage('Спасибо за комментарий!');
            return
        }

        if (chatType === 'advance_report') {
            // Validate all 8 fields are filled
            const requiredFields = [
                ['organizationName', 'Наименование организации'],
                ['headPosition', 'Должность руководителя'],
                ['headFullName', 'ФИО руководителя'],
                ['accountablePerson', 'Подотчетное лицо(фамилия,инициалы)'],
                ['accountablePersonPosition', 'Должность подотчетного лица'],
            ];
            const missing = requiredFields
                .filter(([key]) => !advanceReportForm[key]?.trim())
                .map(([, label]) => label);

            if (missing.length > 0) {
                showToast(`Заполните: ${missing.join(', ')}`, 'error');
                return;
            }

            // Save form data
            try {
                await advancedDataApi.upsertAdvanceReportData({
                    userId,
                    ...advanceReportForm,
                });
                setAdvanceReportSaved(true);
            } catch (err) {
                const backendMessage =
                    err?.response?.data?.message ||
                    err?.response?.data?.error ||
                    'Не удалось сохранить реквизиты авансового отчета';
                showToast(backendMessage, 'error');
                return;
            }

            if (files.length === 0) {
                showToast('Реквизиты сохранены. Теперь прикрепите файлы авансового отчета.', 'info');
                return;
            }
        }

        if (chatType === 'docs_edit') {
            const instruction = inputText.trim();
            if (!instruction) {
                showToast('Введите инструкцию для редактирования документа', 'error');
                trackDocsEvent('docs_edit_error', { code: 400, action: 'validate-text' });
                return;
            }

            const selectedFiles = files.filter(Boolean);
            const invalidFile = selectedFiles.find((file) => !isDocsEditFile(file));
            if (invalidFile) {
                showToast('Разрешены только файлы .docx и .xlsx', 'error');
                trackDocsEvent('docs_edit_error', { code: 400, action: 'validate-file-ext' });
                return;
            }

            let sessionId = null;
            if (selectedFiles.length === 0) {
                sessionId = getLatestDocsEditMeta()?.meta?.sessionId || null;
                if (!sessionId) {
                    sessionId = await resolveDocsEditSessionId();
                }
            }

            if (selectedFiles.length === 0 && !sessionId) {
                showToast('Для первого запроса в docs_edit загрузите .docx или .xlsx', 'error');
                trackDocsEvent('docs_edit_error', { code: 400, action: 'validate-first-file' });
                return;
            }

            try {
                dispatch(setIsWaiting(true));
                setDocsEditStatus(selectedFiles.length > 0 ? 'uploading' : 'editing');

                // optimistic message — чтобы сообщение появлялось сразу
                dispatch((dispatch, getState) => {
                    const current = selectMessages(getState());
                    const temp = {
                        id: Date.now() * -1,
                        text: instruction,
                        sender: 'me',
                        dialogId: newDialogId,
                        userId,
                        chatType: 'docs_edit',
                        type: 'question',
                        pending: true,
                        files: selectedFiles.map((file) => ({ name: file.name })),
                    };
                    dispatch(setMessages([...current, temp]));
                });

                const requestChatType = selectedSubOption || chatType;

                const formData = new FormData();
                if (selectedFiles.length > 0) {
                    selectedFiles.forEach((file) => {
                        formData.append('files', file);
                        formData.append('files_name', file.name);
                    });
                }

                formData.append('dialogId', newDialogId);
                formData.append('userId', userId);
                formData.append('text', instruction);
                formData.append('sender', userEmail);
                formData.append('chatType', requestChatType);
                formData.append('selectedSubOption', selectedSubOption);
                formData.append('isWebSearch', false);

                console.info('[docs_edit] send-file payload', {
                    dialogId: newDialogId,
                    userId,
                    chatType,
                    selectedSubOption,
                    requestChatType,
                    hasFile: selectedFiles.length > 0,
                    filesCount: selectedFiles.length,
                    sessionId: sessionId || null,
                });

                if (sessionId) {
                    formData.append('sessionId', sessionId);
                    trackDocsEvent('docs_edit_followup_sent', { sessionId, dialogId: newDialogId });
                } else if (selectedFiles.length > 0) {
                    trackDocsEvent('docs_edit_new_chain_started', { dialogId: newDialogId });
                }

                dispatch(setInput(''));

                // Clear selected file right after submit so it does not stay in picker during processing.
                if (selectedFiles.length > 0) {
                    clearSelectedFiles();
                }

                if (selectedFiles.length > 0) {
                    setDocsEditStatus('editing');
                }

                await chatApi.sendFile(formData);

                // fallback, если сокет не дойдёт или придёт неполный
                setTimeout(() => fetchMessages(newDialogId), 500);
                setTimeout(() => fetchMessages(newDialogId), 1500);
                setTimeout(() => fetchMessages(newDialogId), 3000);

                showToast('Запрос отправлен', 'info');
            } catch (error) {
                const status = error?.response?.status;
                const backendMessage =
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.response?.data?.detail ||
                    '';

                console.warn('[docs_edit] send-file failed, attempting continueFromLatest fallback', {
                    status,
                    backendData: error?.response?.data,
                    hasLocalSessionId: Boolean(sessionId),
                });

                // Пытаемся отправить как "continue from latest" (без файла)
                try {
                    let fallbackSessionId = sessionId;

                    // Если нет локальной sessionId - получаем из последнего message
                    if (!fallbackSessionId && messages.length > 0) {
                        const lastMessage = messages[messages.length - 1];
                        const lastMessageId = lastMessage?.id;

                        console.info('[docs_edit] fetching session from last message', {
                            lastMessageId,
                            sender: lastMessage?.sender,
                        });

                        if (lastMessageId) {
                            try {
                                const sessionData = await chatApi.getSession(userId, lastMessageId);
                                fallbackSessionId = sessionData?.data?.sessionId || sessionData?.sessionId;

                                console.info('[docs_edit] got session from API', {
                                    fallbackSessionId,
                                    version: sessionData?.data?.version,
                                });
                            } catch (sessionErr) {
                                console.error('[docs_edit] failed to get session', sessionErr);
                            }
                        }
                    }

                    // Отправляем как continueFromLatest через сокет (без файла, только sessionId + инструкция)
                    if (fallbackSessionId && instruction?.trim() && socket && socket.connected) {
                        const docsSendMsg = {
                            text: instruction,
                            sender: userEmail,
                            dialogId: newDialogId,
                            userId,
                            chatType: 'docs_edit',
                            selectedSubOption: 'docs_edit',
                            sessionId: fallbackSessionId,
                            isWebSearch: false,
                        };

                        console.info('[docs_edit] sending continueFromLatest via socket', {
                            sessionId: fallbackSessionId,
                            hasInstruction: true,
                        });

                        socket.emit('sendMessage', docsSendMsg, (ack) => {
                            if (isSocketAckSuccess(ack)) {
                                console.info('[docs_edit] socket continueFromLatest success', ack);
                                setDocsEditStatus('done');
                                showToast('Продолжено с предыдущей версии', 'info');
                                fetchMessages(newDialogId);
                                trackDocsEvent('docs_edit_continue_success', { sessionId: fallbackSessionId });
                            } else {
                                console.warn('[docs_edit] socket continueFromLatest ack failed', ack);
                                showToast('Ошибка отправки инструкции', 'error');
                                setDocsEditStatus('error');
                                trackDocsEvent('docs_edit_error_no_session', { code: 'socket_ack_failed' });
                            }
                        });
                    } else {
                        // Не смог получить sessionId или нет сокета
                        showToast(backendMessage || 'Не удалось отправить данные. Повторите позже', 'error');
                        setDocsEditStatus('error');
                        trackDocsEvent('docs_edit_error_no_session', {
                            code: status || 'network',
                            hasSessionId: Boolean(fallbackSessionId),
                            socketConnected: Boolean(socket?.connected),
                        });
                    }
                } catch (fallbackErr) {
                    console.error('[docs_edit] continueFromLatest fallback failed', fallbackErr);
                    showToast('Ошибка отправки резервного запроса. Повторите позже', 'error');
                    setDocsEditStatus('error');
                    trackDocsEvent('docs_edit_error_fallback_failed', {
                        code: fallbackErr?.response?.status || 'network'
                    });
                }
            } finally {
                clearSelectedFiles();
            }

            return;
        }

        if (chatType === 'okof_identifyer') {
            if (!form.name.trim() && !form.description.trim()) return;


            const okofPayload = JSON.stringify({
                name: form.name,
                description: form.description,
            });

            const newMessage = {
                text: okofPayload,
                sender: userEmail,
                dialogId: newDialogId,
                userId,
                chatType,
                selectedSubOption,
                isWebSearch,
                isStorageUse,
            };

            dispatch(setIsWaiting(true));
            // optimistic append so user sees their message immediately
            dispatch((dispatch, getState) => {
                const current = selectMessages(getState());
                const temp = {
                    id: Date.now() * -1,
                    text: okofPayload,
                    sender: 'me',
                    dialogId: newDialogId,
                    userId,
                    chatType,
                    type: 'question',
                    pending: true,
                };
                dispatch(setMessages([...current, temp]));
            });

            socket.emit('sendMessage', newMessage, (ack) => {
                // if server ack returns message or status, we could refresh messages
                if (isSocketAckSuccess(ack) && ack.refresh) {
                    fetchMessages(newDialogId);
                }
            });

            // очистка формы
            setForm({ name: '', description: '' });

            return;
        }


        const latestDocsEdit = files.length === 0 ? getLatestDocsEditMeta() : null;
        const shouldContinueDocumentEdit =
            Boolean(latestDocsEdit?.meta?.sessionId) &&
            looksLikeDocumentEditIntent(inputText);
        const outgoingChatType = shouldContinueDocumentEdit ? 'docs_edit' : chatType;
        const outgoingSelectedSubOption = shouldContinueDocumentEdit ? 'docs_edit' : selectedSubOption;

        const newMessage = {
            text: input,
            sender: userEmail,
            dialogId: newDialogId,
            userId,
            chatType: outgoingChatType,
            selectedSubOption: outgoingSelectedSubOption,
            isWebSearch,
            isStorageUse,
            ...(shouldContinueDocumentEdit ? { sessionId: latestDocsEdit.meta.sessionId } : {})
        };

        if (files.length === 0 && (!socket || !socket.connected)) {
            showToast('Нет соединения с сервером. Попробуйте позже', 'error');
            return;
        }

        dispatch(setInput(''))
        dispatch(setIsWaiting(true))

        if (files.length > 0) {
            try {
                // optimistic message для файлового сообщения
                dispatch((dispatch, getState) => {
                    const current = selectMessages(getState());
                    const temp = {
                        id: Date.now() * -1,
                        text: input,
                        sender: 'me',
                        dialogId: newDialogId,
                        userId,
                        chatType,
                        type: 'question',
                        pending: true,
                        files: files.map((file) => ({ name: file.name })),
                    };
                    dispatch(setMessages([...current, temp]));
                });

                const requestChatType = selectedSubOption || chatType;
                const formData = new FormData();
                files.forEach((file, idx) => {
                    // ////console.log('file', file)
                    formData.append(`files`, file)
                });
                const fileNames = files.map(file => file.name).join(', '); // Получаем имена файлов через запятую
                formData.append('files_name', fileNames);
                formData.append('dialogId', newDialogId);
                formData.append('userId', userId);
                formData.append('text', input);
                formData.append('sender', userEmail);
                formData.append('chatType', requestChatType);
                formData.append('selectedSubOption', selectedSubOption);
                formData.append('isWebSearch', isWebSearch);

                clearSelectedFiles();

                const response = await chatApi.sendFile(formData);

                setProgress(0);
                setIsAnalysisComplete(true);

                // Подтягиваем актуальные сообщения после загрузки файла
                await fetchMessages(newDialogId);

                dispatch(setIsWaiting(false));

            } catch (error) {
                console.error('error occured while sending the file', error);
                dispatch(setIsWaiting(false))
            }
        }
        else {
            // ////console.log('socket.emit start', isBindPay)
            // if (!input.trim() || !isBindPay) return; //todo
            if (!inputText.trim()) return;
            ////console.log('socket.emit', newMessage)
            if (!socket) {
                console.warn('Socket not ready — cannot send message');
            } else if (!socket.connected) {
                console.warn('Socket not connected — cannot send message');
            } else {
                // optimistic append
                dispatch((dispatch, getState) => {
                    const current = selectMessages(getState());
                    const temp = {
                        id: Date.now() * -1,
                        text: newMessage.text,
                        sender: 'me',
                        dialogId: newDialogId,
                        userId,
                        chatType: outgoingChatType,
                        type: 'question',
                        pending: true,
                    };
                    dispatch(setMessages([...current, temp]));
                });

                socket.emit('sendMessage', newMessage, (ack) => {
                    if (!isSocketAckSuccess(ack)) console.warn('sendMessage ack:', ack);
                    // optionally refresh messages if server indicates
                    if (isSocketAckSuccess(ack) && ack.refresh) {
                        fetchMessages(newDialogId);
                    }
                });
            }
        }
    };

    const handleSelectDialog = async (dialogIdFromSide) => {
        setLoading(true);
        // ////console.log('dialogIdFromSide', dialogIdFromSide)

        const selectedDialog = dialogs.find(dialog => dialog.id === dialogIdFromSide);


        dispatch(setDialogId(dialogIdFromSide))
        dispatch(setDialogName(selectedDialog ? selectedDialog.name : ''));

        dispatch(setMode('chat'))
        localStorage.setItem(`lastDialogId_${userId}`, dialogIdFromSide);
        await initAndJoin(dialogIdFromSide)
        await fetchMessages(dialogIdFromSide);

    };

    const handleSendMessageToLawyer = async () => {
        const details = `${userDetails.name ?? ''}, ${userDetails.inn ?? ''}`;

        const question = input;
        try {
            const res_send = await chatApi.sendMessageToLawyer(userId, dialogId, details, question);
            // ////console.log('Сообщение отправлено юристу', res_send.data);
            if (res_send.data.status === 'error') {
                const newMessage = {
                    id: 0,
                    text: 'Необходимо авторизоваться в телеграм',
                    sender: 'BotTax',
                    dialog_id: dialogId,
                    type: 'system'
                };
                dispatch(setMessages(([...messages, newMessage])))
                // ////console.log('nnn', newMessage)
                if (newMessage.sender !== 'me' || newMessage.sender === 'system' || newMessage.sender === 'BotTax') {
                    dispatch(setIsWaiting(false));
                    dispatch(setRatingMessageId(newMessage.id))
                } else {
                    // setIsWaiting(true); //todo
                }
            }
            else {
                const newMessage = {
                    id: 0,
                    text: 'Ваше сообщение отправлено',
                    sender: 'BotTax',
                    dialog_id: dialogId,
                    type: 'system'
                };
                dispatch(setMessages(([...messages, newMessage])))
                // //console.log('nnn', newMessage)
                if (newMessage.sender !== 'me' || newMessage.sender === 'system' || newMessage.sender === 'BotTax') {
                    dispatch(setIsWaiting(false));
                    dispatch(setRatingMessageId(newMessage.id))
                } else {
                    // setIsWaiting(true); //todo
                }
            }
        } catch (err) {
            console.error('Ошибка отправки сообщения юристу:', err);
        } finally {
            dispatch(setInput(''))
            setIsAwaitingQuestion(false);
            dispatch(setRole(''))
            setUserDetails({ name: '', inn: '' })
        }
    }

    const newSystemMessage = (text) => {
        const newMessage = {
            id: 0,
            text: text,
            sender: 'BotTax',
            dialog_id: dialogId,
            type: 'system',
            comment: 'rate'
        };
        // dispatch(setMessages(([...messages, newMessage])))
        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState()); // Получаем актуальные сообщения
            dispatch(setMessages([...currentMessages, newMessage])); // Добавляем новое сообщение
        });
    }

    const setRatingMessage = async (comment) => {
        try {
            await chatApi.submitRating(ratingMessageId, rating, comment);
            dispatch(setRatingMessageId(null))

        } catch (err) {
            console.error('error while rating', err)
        }
    }

    const handleRating = async (rating) => {
        // //console.log('handleRating', ratingMessageId);
        setRating(rating);
        if (!ratingMessageId) return;
        setIsAwaitingRateComment(true);
        newSystemMessage('Пожалуйста, оставьте комментарий или нажмите "Пропустить"');
    }

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files || []);

        if (chatType === 'docs_edit') {
            if (newFiles.length === 0) return;

            const docsEditFiles = newFiles.filter((file) => isDocsEditFile(file));
            const hasInvalidFiles = docsEditFiles.length !== newFiles.length;

            if (hasInvalidFiles) {
                showToast('В docs_edit можно загружать только .docx или .xlsx', 'error');
                trackDocsEvent('docs_edit_error', { code: 400, action: 'upload-ext' });
            }

            if (docsEditFiles.length === 0) {
                e.target.value = '';
                return;
            }

            setFiles((prevFiles) => [...prevFiles, ...docsEditFiles]);
            e.target.value = '';
            return;
        }

        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        e.target.value = '';
    };

    const handleSendFile = async () => {
        if (files.length > 0) {
            try {
                const formData = new FormData();
                files.forEach((file, idx) => formData.append(`file${idx}`, file));
                formData.append('dialogId', dialogId);
                formData.append('userId', 11);
                await chatApi.sendFile(formData);
                clearSelectedFiles();
            } catch (error) {
                console.error('error occured while sending the file', error);
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    const handleInputChange = (e) => {
        dispatch(setInput(e.target.value));
    };

    const applySpeechPreviewToInput = useCallback(() => {
        const previewText = `${speechTranscriptRef.current} ${webSpeechInterimRef.current}`.trim();
        const nextInput = `${speechBaseInputRef.current} ${previewText}`.trim();
        dispatch(setInput(nextInput));
    }, [dispatch]);

    const mergeTranscript = (existingText, newChunk) => {
        const existing = (existingText || '').trim();
        const chunk = (newChunk || '').trim();

        if (!chunk) return existing;
        if (!existing) return chunk;
        if (existing === chunk) return existing;

        const existingWords = existing.split(/\s+/);
        const chunkWords = chunk.split(/\s+/);

        const maxOverlap = Math.min(existingWords.length, chunkWords.length);
        let overlap = 0;

        for (let i = maxOverlap; i > 0; i -= 1) {
            const existingTail = existingWords.slice(-i).join(' ');
            const chunkHead = chunkWords.slice(0, i).join(' ');
            if (existingTail === chunkHead) {
                overlap = i;
                break;
            }
        }

        if (overlap > 0) {
            return `${existing} ${chunkWords.slice(overlap).join(' ')}`.trim();
        }

        if (existing.includes(chunk)) return existing;

        return `${existing} ${chunk}`.trim();
    };

    const clearSpeechTimers = () => {
        if (speechSilenceTimeoutRef.current) {
            clearTimeout(speechSilenceTimeoutRef.current);
            speechSilenceTimeoutRef.current = null;
        }

        if (speechStopTimerRef.current) {
            clearTimeout(speechStopTimerRef.current);
            speechStopTimerRef.current = null;
        }

        if (restartTimeoutRef.current) {
            clearTimeout(restartTimeoutRef.current);
            restartTimeoutRef.current = null;
        }

        if (maxRecordingTimerRef.current) {
            clearTimeout(maxRecordingTimerRef.current);
            maxRecordingTimerRef.current = null;
        }
    };

    const releaseMicStream = () => {
        if (micStreamRef.current) {
            micStreamRef.current.getTracks().forEach(t => t.stop());
            micStreamRef.current = null;
        }
    };

    const startSpeechRecording = async () => {
        try {
            if (isSpeechRecordingRef.current) return;

            const SpeechRecognitionClass =
                window.SpeechRecognition || window.webkitSpeechRecognition;

            if (!SpeechRecognitionClass) {
                showToast('Голосовой ввод не поддерживается на этом устройстве', 'error');
                return;
            }

            // Запрашиваем разрешение на микрофон заранее (гарантирует появление диалога на iOS/Android)
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                micStreamRef.current = stream;
            } catch (micErr) {
                console.warn('Microphone permission denied:', micErr);
                showToast('Нет доступа к микрофону. Разрешите доступ в настройках браузера.', 'error');
                return;
            }

            clearSpeechTimers();

            speechBaseInputRef.current = inputText;
            speechTranscriptRef.current = '';
            webSpeechInterimRef.current = '';
            lastFinalChunkRef.current = '';
            isManuallyStoppingRef.current = false;
            restartAttemptsRef.current = 0;

            const recognition = new SpeechRecognitionClass();

            const userAgent = navigator.userAgent || '';
            // Все браузеры на iOS используют WebKit — проверяем именно iOS, не только Safari
            const isIOS = /iPad|iPhone|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            const isAndroid = /android/i.test(userAgent);
            const isMobileDevice = isIOS || isAndroid;

            recognition.lang = 'ru-RU';
            recognition.interimResults = true;
            // На мобильных (iOS и Android) continuous режим нестабилен — отключаем и перезапускаем вручную
            recognition.continuous = !isMobileDevice;
            recognition.maxAlternatives = 1;

            const MAX_RESTART_ATTEMPTS = isMobileDevice ? 50 : 5;
            const SILENCE_TIMEOUT_MS = isMobileDevice ? 8000 : 7000;
            const MAX_RECORDING_MS = 5 * 60 * 1000; // 5 минут максимум

            const resetSilenceTimer = () => {
                if (speechSilenceTimeoutRef.current) {
                    clearTimeout(speechSilenceTimeoutRef.current);
                    speechSilenceTimeoutRef.current = null;
                }
                speechSilenceTimeoutRef.current = setTimeout(() => {
                    if (isSpeechRecordingRef.current) {
                        stopSpeechRecording();
                    }
                }, SILENCE_TIMEOUT_MS);
            };

            recognition.onstart = () => {
                isSpeechRecordingRef.current = true;
                setIsRecordingSpeech(true);
                restartAttemptsRef.current = 0;
                resetSilenceTimer();
            };

            recognition.onresult = (event) => {
                let interimText = '';

                for (let i = event.resultIndex; i < event.results.length; i += 1) {
                    const transcript = (event.results[i][0]?.transcript || '').trim();
                    if (!transcript) continue;

                    if (event.results[i].isFinal) {
                        speechTranscriptRef.current = mergeTranscript(
                            speechTranscriptRef.current,
                            transcript
                        );
                        lastFinalChunkRef.current = transcript;
                    } else {
                        interimText = transcript;
                    }
                }

                webSpeechInterimRef.current = interimText;
                applySpeechPreviewToInput();
                // Сбрасываем таймер тишины при каждом результате
                resetSilenceTimer();
            };

            recognition.onerror = (event) => {
                console.warn('WebSpeech error:', event.error);

                if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
                    showToast('Нет доступа к микрофону', 'error');
                    stopSpeechRecording();
                    return;
                }

                if (event.error === 'audio-capture') {
                    showToast('Микрофон недоступен', 'error');
                    stopSpeechRecording();
                    return;
                }

                // no-speech / aborted — пусть onend перезапустит на всех платформах
                if (event.error === 'no-speech' || event.error === 'aborted') {
                    return;
                }

                stopSpeechRecording();
            };

            recognition.onend = () => {
                webSpeechInterimRef.current = '';

                const finalPreview = `${speechTranscriptRef.current}`.trim();
                const finalInput = `${speechBaseInputRef.current} ${finalPreview}`.trim();
                dispatch(setInput(finalInput));

                if (isManuallyStoppingRef.current) {
                    isSpeechRecordingRef.current = false;
                    setIsRecordingSpeech(false);
                    releaseMicStream();
                    return;
                }

                if (!isSpeechRecordingRef.current) {
                    setIsRecordingSpeech(false);
                    releaseMicStream();
                    return;
                }

                // Лимит попыток перезапуска (защита от бесконечного цикла)
                restartAttemptsRef.current += 1;
                if (restartAttemptsRef.current > MAX_RESTART_ATTEMPTS) {
                    console.warn('WebSpeech: превышено количество перезапусков');
                    isSpeechRecordingRef.current = false;
                    setIsRecordingSpeech(false);
                    releaseMicStream();
                    return;
                }

                if (restartTimeoutRef.current) {
                    clearTimeout(restartTimeoutRef.current);
                    restartTimeoutRef.current = null;
                }

                // На мобильных continuous=false, поэтому onend срабатывает после каждой фразы.
                // Перезапускаем с задержкой — микрофон уже разрешён через getUserMedia.
                const restartDelay = isIOS ? 350 : (isAndroid ? 300 : 120);

                restartTimeoutRef.current = setTimeout(() => {
                    if (!isSpeechRecordingRef.current || isManuallyStoppingRef.current) return;
                    try {
                        recognition.start();
                    } catch (e) {
                        console.warn('Ошибка перезапуска WebSpeech:', e);
                        // На мобильных при ошибке перезапуска пробуем создать новый экземпляр
                        if (isMobileDevice && restartAttemptsRef.current <= MAX_RESTART_ATTEMPTS) {
                            try {
                                const newRecognition = new SpeechRecognitionClass();
                                newRecognition.lang = recognition.lang;
                                newRecognition.interimResults = true;
                                newRecognition.continuous = false;
                                newRecognition.maxAlternatives = 1;
                                newRecognition.onstart = recognition.onstart;
                                newRecognition.onresult = recognition.onresult;
                                newRecognition.onerror = recognition.onerror;
                                newRecognition.onend = recognition.onend;
                                webSpeechRef.current = newRecognition;
                                newRecognition.start();
                            } catch (e2) {
                                console.warn('Mobile fallback restart failed:', e2);
                                isSpeechRecordingRef.current = false;
                                setIsRecordingSpeech(false);
                                releaseMicStream();
                            }
                        } else {
                            isSpeechRecordingRef.current = false;
                            setIsRecordingSpeech(false);
                            releaseMicStream();
                        }
                    }
                }, restartDelay);
            };

            webSpeechRef.current = recognition;
            isSpeechRecordingRef.current = true;
            setIsRecordingSpeech(true);

            // Ограничение максимальной длительности записи
            maxRecordingTimerRef.current = setTimeout(() => {
                if (isSpeechRecordingRef.current) {
                    stopSpeechRecording();
                }
            }, MAX_RECORDING_MS);

            recognition.start();
        } catch (err) {
            console.error('Ошибка запуска записи:', err);
            showToast('Не удалось запустить голосовой ввод', 'error');
            stopSpeechRecording();
        }
    };


    // const sendAudioToSpeechApi = async (audioBlob) => {
    //     const formData = new FormData();
    //     formData.append('audio', audioBlob, 'recording.webm');

    //     const response = await fetch(process.env.REACT_APP_API_URL_CHAT+'/api/speech-to-text', {
    //         method: 'POST',
    //         body: formData,
    //     });

    //     if (!response.ok) {
    //         throw new Error(`STT request failed: ${response.status}`);
    //     }

    //     return response.json();
    // };

    const stopSpeechRecording = () => {
        isManuallyStoppingRef.current = true;
        isSpeechRecordingRef.current = false;
        setIsRecordingSpeech(false);

        clearSpeechTimers();

        const finalPreview = `${speechTranscriptRef.current} ${webSpeechInterimRef.current}`.trim();
        const finalInput = `${speechBaseInputRef.current} ${finalPreview}`.trim();

        dispatch(setInput(finalInput));

        webSpeechInterimRef.current = '';

        if (webSpeechRef.current) {
            const recognition = webSpeechRef.current;
            webSpeechRef.current = null;

            recognition.onresult = null;
            recognition.onerror = null;
            recognition.onend = null;

            try {
                recognition.stop();
            } catch (e) {
                console.warn('Ошибка остановки WebSpeech:', e);
            }
        }

        releaseMicStream();
    };


    const toggleSpeechRecording = () => {
        if (isSpeechRecordingRef.current) {
            stopSpeechRecording();
        } else {
            startSpeechRecording();
        }
    };

    useEffect(() => {
        return () => {
            stopSpeechRecording();
        };
    }, []);

    const handleClickToDialogs = () => {
        dispatch(setMode('dialogs'))
    }

    const handleRoleSelection = (selectedRole) => {
        setRole(selectedRole);
        dispatch(setIsAwaitingRole(false))
        setIsAwaitingDetails(true);
    };

    // function formatText(text) {
    //     if (!text) return ""; // Если текст пустой, возвращаем пустую строку

    //     // Замена **текст** на <strong>текст</strong>
    //     const boldReplaced = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    //     const tripleHashReplaced = boldReplaced.replace(/###/g, "<br>");

    //     // Замена переносов строки на <br>
    //     const lineBreakReplaced = tripleHashReplaced.replace(/\n/g, "<br>");

    //     return lineBreakReplaced;
    // }
    function formatText(text, urls, urls_title) {
        if (!text) return "";

        if (Array.isArray(urls)) {
            urls = urls.join("\n");
        } else if (typeof urls !== "string") {
            urls = "";
        }

        if (Array.isArray(urls_title)) {
            urls_title = urls_title.join('\n')
        } else if (typeof urls_title !== 'string') {
            urls_title = '';
        }
        // Вставим CSS стили один раз
        let styleTag = `
    <style>
        .custom-table table {
            border-collapse: collapse;
            width: 100%;
            margin: 15px 0;
            font-family: Arial, sans-serif;
        }
        .custom-table th, .custom-table td {
            border: 1px solid #ccc;
            padding: 8px 12px;
            text-align: left;
            vertical-align: top;
        }
        .custom-table th {
            background-color: #f2f2f2;
            font-weight: bold;
        }
        .custom-table tr:nth-child(even) {
            background-color: #fafafa;
        }
    </style>`;

        // Обработка блока table: { ... }
        const tableMatch = text.match(/table:\s*({[\s\S]*?}\s*)/);
        let tableHTML = "";

        if (tableMatch) {
            try {
                const jsonStr = tableMatch[1];
                const tableObj = eval('(' + jsonStr + ')');

                tableHTML += `<div class="custom-table"><table><thead><tr>`;
                tableObj.headers.forEach(header => {
                    tableHTML += `<th>${header}</th>`;
                });
                tableHTML += `</tr></thead><tbody>`;
                tableObj.rows.forEach(row => {
                    tableHTML += `<tr>`;
                    row.forEach(cell => {
                        tableHTML += `<td>${cell}</td>`;
                    });
                    tableHTML += `</tr>`;
                });
                tableHTML += `</tbody></table></div>`;

                // Заменяем table-блок на HTML таблицу
                text = text.replace(/table:\s*{[\s\S]*?}\s*/, styleTag + tableHTML);
            } catch (e) {
                console.error("Ошибка при парсинге таблицы:", e);
            }
        }

        // Прочее форматирование
        const boldReplaced = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
        const tripleHashReplaced = boldReplaced.replace(/###/g, "<br>");
        const lineBreakReplaced = tripleHashReplaced.replace(/\n/g, "<br>");

        let html = text
            .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
            .replace(/###/g, "<br>")
            .replace(/\n/g, "<br>");

        if (urls) {
            let linkCounter = 1;
            const urlRegex = /(https?:\/\/[^\s,]+)/g;

            const linksHTML = urls.replace(urlRegex, (url) => {
                let domain = url;
                try {
                    domain = new URL(url).hostname.replace(/^www\./, "");
                } catch { }

                const title = urls_title || domain;

                return `<br>${linkCounter++}) <a href="${url}" target="_blank" rel="noopener noreferrer">${title}</a>`;
            });

            html += `<br><br><strong>Источники:</strong>${linksHTML}`;
        }

        return html;
    }




    const handleSkipToDialog = async () => {
        // await handleStartNewDialog();
        dispatch(setIsAwaitingRole(false));
        setIsAwaitingDetails(false);
        setIsAwaitingQuestion(false);
        setUserDetails({ name: '', inn: '' });
        setRole('');
        dispatch(setInput(''));
    };

    const handleSkipRateComment = async () => {
        setIsAwaitingRateComment(false);
        setRatingMessage(null)
        dispatch(setInput(''));
    };

    // const initAndJoin = async (dialogId) => {
    //     try {
    //         dispatch(setIsAwaitingRole(false))
    //         setIsAwaitingDetails(false);
    //         setIsAwaitingQuestion(false);
    //         // ensure socket exists/connected (wait briefly if needed)
    //         const waitForSocket = (timeout = 3000) => new Promise((resolve) => {
    //             const start = Date.now();
    //             const t = setInterval(() => {
    //                 if (socket && socket.connected) {
    //                     clearInterval(t);
    //                     resolve(true);
    //                 } else if (Date.now() - start > timeout) {
    //                     clearInterval(t);
    //                     resolve(false);
    //                 }
    //             }, 100);
    //         });

    //         // const isReady = socket && socket.connected ? true : await waitForSocket(3000);
    //         // if (!socket) {
    //         //     console.warn('Socket not ready — cannot join dialog', dialogId);
    //         //     return;
    //         // }
    //         // if (!isReady) {
    //         //     console.warn('Socket not connected after wait — joinDialog skipped', dialogId);
    //         // } else {
    //         //     socket.emit('joinDialog', { dialogId }, (ack) => {
    //         //         if (!ack || ack?.status !== 'ok') console.warn('joinDialog ack:', ack);
    //         //     });
    //         // }
    //     } catch (error) {
    //         console.error('error while joining dialog', error);
    //     }
    // };

    const initAndJoin = async (dialogId) => {
        try {
            dispatch(setIsAwaitingRole(false))
            setIsAwaitingDetails(false);
            setIsAwaitingQuestion(false);

            if (socket && socket.connected) {
                socket.emit('joinDialog', { dialogId }, (ack) => {
                    if (!isSocketAckSuccess(ack)) console.warn('joinDialog ack:', ack);
                });
            }
        } catch (error) {
            console.error('error while joining dialog', error);
        }
    };


    useEffect(() => {
        if (!socket || !dialogId) return;

        const joinCurrentDialog = () => {
            socket.emit('joinDialog', { dialogId }, (ack) => {
                //console.log('Joined dialog:', dialogId, ack);
            });
        };

        socket.on('connect', joinCurrentDialog);

        // Если уже подключен
        if (socket.connected) {
            joinCurrentDialog();
        }

        return () => {
            socket.off('connect', joinCurrentDialog);
        };
    }, [socket, dialogId]);




    // const disableSendButton = !isBindPay || (files.length === 0 && input.trim() === '')
    const disableSendButton =
        files.length === 0 &&
        (
            (chatType === 'okof_identifyer'
                ? !form.name.trim() && !form.description.trim()
                : chatType === 'advance_report'
                    ? Object.values(advanceReportForm).every(v => !v.trim())
                    : !inputText.trim()
            )
        );



    // useEffect(() => {
    //     checkAuth();
    // }, []);

    // useEffect(() => {
    //     if (auth && isBindPay) fetchMessages();
    // }, [auth]);
    const dialogIdRef = useRef(dialogId);
    useEffect(() => {
        dialogIdRef.current = dialogId;
    }, [dialogId]);

    useEffect(() => {
        if (!userId || !dialogId) return;

        (async () => {
            try {
                setLoading(true);
                await fetchMessages(dialogId);
            } catch (e) {
                console.error('fetchMessages useEffect error', e);
            }
        })();
    }, [dialogId, userId]);
    // const handleSocket = (newMessage) => {

    //     // dispatch((dispatch, getState) => {
    //     //     const currentDialogId = selectDialogId(getState()); 
    //     //     //console.log('soket newMessage', newMessage, currentDialogId)
    //     //     if (parseInt(newMessage.dialogId) !== parseInt(currentDialogId) && parseInt(newMessage.dialog_id) !== parseInt(currentDialogId)) {
    //     //         //console.log(newMessage.dialogId, newMessage.dialog_id, parseInt(currentDialogId))
    //     //         return;
    //     //     }
    //     // }); 
    //     // //console.log('soket newMessage', newMessage, dialogIdRef.current)
    //     if (parseInt(newMessage.dialogId) !== parseInt(dialogIdRef.current) && parseInt(newMessage.dialog_id) !== parseInt(dialogIdRef.current)) {
    //         // //console.log(newMessage.dialogId, newMessage.dialog_id, parseInt(dialogIdRef.current))
    //         return;
    //     }

    //     reloadDialogs()
    //     // dispatch(setMessages(([...messages, newMessage])))

    //     dispatch((dispatch, getState) => {
    //         const currentMessages = selectMessages(getState()); // Получаем актуальные сообщения
    //         dispatch(setMessages([...currentMessages, newMessage])); // Добавляем новое сообщение
    //     });


    //     if (newMessage.sender === 'system' || newMessage.sender === 'BotTax') {
    //         dispatch(setIsWaiting(false));
    //         setProgress(0)
    //         dispatch(setRatingMessageId(newMessage.id))
    //     } else {
    //         // setIsWaiting(true);//todo
    //     }
    // };

    const handleSocket = (newMessage) => {
        if (
            parseInt(newMessage.dialogId) !== parseInt(dialogIdRef.current) &&
            parseInt(newMessage.dialog_id) !== parseInt(dialogIdRef.current)
        ) {
            return;
        }

        reloadDialogs();

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());

            const streamedIndex = newMessage.streamId
                ? currentMessages.findIndex((msg) => msg.streamId === newMessage.streamId)
                : -1;

            const existingIndex = currentMessages.findIndex(
                (msg) =>
                    msg.pending &&
                    msg.sender === 'me' &&
                    msg.text === newMessage.text
            );

            if (streamedIndex !== -1 && newMessage.sender === 'BotTax') {
                const updated = [...currentMessages];
                const streamedMessage = updated[streamedIndex];
                updated[streamedIndex] = {
                    ...streamedMessage,
                    ...newMessage,
                    executionTrace: Array.isArray(newMessage.executionTrace) && newMessage.executionTrace.length > 0
                        ? newMessage.executionTrace
                        : streamedMessage.executionTrace,
                    streaming: false,
                };
                dispatch(setMessages(updated));
            } else if (existingIndex !== -1) {
                const updated = [...currentMessages];
                updated[existingIndex] = { ...newMessage, sender: 'me', pending: false };
                dispatch(setMessages(updated));
            } else {
                dispatch(setMessages([...currentMessages, newMessage]));
            }
        });

        if (newMessage.sender === 'system' || newMessage.sender === 'BotTax') {
            dispatch(setIsWaiting(false));
            setProgress(0);
            dispatch(setRatingMessageId(newMessage.id));

            const hasWorkflowDocument =
                Boolean(newMessage.originalFile && newMessage.editedFile) ||
                Boolean(newMessage.sessionId && newMessage.editedFile);

            const isDocsEditMessage =
                newMessage.chatType === 'docs_edit' ||
                newMessage.chatType === 'advance_report' ||
                chatType === 'docs_edit' ||
                chatType === 'advance_report' ||
                hasWorkflowDocument;

            if (isDocsEditMessage) {
                setDocsEditStatus('editing');

                // Всегда подтягиваем полную историю из API,
                // потому что сокет может прийти без editedFiles / preview metadata
                fetchMessages(dialogIdRef.current)
                    .then(() => {
                        setDocsEditStatus('done');
                    })
                    .catch((err) => {
                        console.error('docs_edit fetchMessages after socket error', err);
                        setDocsEditStatus('error');
                    });
            }
        }
    };

    const isCurrentStreamDialog = useCallback((data = {}) => {
        const streamDialogId = data.dialogId ?? data.dialog_id;
        return String(streamDialogId ?? '') === String(dialogIdRef.current ?? '');
    }, []);

    const handleAiStreamStart = useCallback((data = {}) => {
        if (!data.streamId || !isCurrentStreamDialog(data)) return;

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            if (currentMessages.some((msg) => msg.streamId === data.streamId)) return;

            dispatch(setMessages([...currentMessages, {
                id: `stream_${data.streamId}`,
                streamId: data.streamId,
                text: '',
                sender: 'BotTax',
                dialog_id: data.dialog_id ?? data.dialogId,
                dialogId: data.dialogId ?? data.dialog_id,
                chatType: data.chatType,
                type: 'answer',
                streaming: true,
                streamStartedAt: Date.now(),
                executionTrace: [{
                    id: 'thinking-placeholder',
                    stage: 'analysis',
                    status: 'running',
                    title: 'Анализирует запрос',
                    message: 'Определяет, какую информацию использовать',
                }],
            }]));
        });
    }, [dispatch, isCurrentStreamDialog]);

    const handleAiStreamTrace = useCallback((data = {}) => {
        const trace = data.trace;
        if (!data.streamId || !trace?.id || !isCurrentStreamDialog(data)) return;

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            const streamIndex = currentMessages.findIndex((msg) => msg.streamId === data.streamId);
            const updated = [...currentMessages];

            const upsertTrace = (items = []) => {
                const traces = Array.isArray(items)
                    ? items.filter((item) => item.id !== 'thinking-placeholder')
                    : [];
                const traceIndex = traces.findIndex((item) => item.id === trace.id);
                if (traceIndex >= 0) {
                    traces[traceIndex] = { ...traces[traceIndex], ...trace };
                } else {
                    traces.push(trace);
                }
                return traces;
            };

            if (streamIndex === -1) {
                updated.push({
                    id: `stream_${data.streamId}`,
                    streamId: data.streamId,
                    text: '',
                    sender: 'BotTax',
                    dialog_id: data.dialog_id ?? data.dialogId,
                    dialogId: data.dialogId ?? data.dialog_id,
                    type: 'answer',
                    streaming: true,
                    streamStartedAt: Date.now(),
                    executionTrace: [trace],
                });
            } else {
                updated[streamIndex] = {
                    ...updated[streamIndex],
                    executionTrace: upsertTrace(updated[streamIndex].executionTrace),
                };
            }

            dispatch(setMessages(updated));
        });
    }, [dispatch, isCurrentStreamDialog]);

    const handleAiStreamDelta = useCallback((data = {}) => {
        if (!data.streamId || typeof data.delta !== 'string' || !isCurrentStreamDialog(data)) return;

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            const streamIndex = currentMessages.findIndex((msg) => msg.streamId === data.streamId);
            const updated = [...currentMessages];

            if (streamIndex === -1) {
                updated.push({
                    id: `stream_${data.streamId}`,
                    streamId: data.streamId,
                    text: data.delta,
                    sender: 'BotTax',
                    dialog_id: data.dialog_id ?? data.dialogId,
                    dialogId: data.dialogId ?? data.dialog_id,
                    type: 'answer',
                    streaming: true,
                    streamStartedAt: Date.now(),
                });
            } else {
                const executionTrace = Array.isArray(updated[streamIndex].executionTrace)
                    ? updated[streamIndex].executionTrace.filter((item) => item.id !== 'thinking-placeholder')
                    : [];
                const generationIndex = executionTrace.findIndex((item) => item.stage === 'generation');
                const generationTrace = {
                    id: generationIndex >= 0 ? executionTrace[generationIndex].id : 'generation-fallback',
                    stage: 'generation',
                    status: 'streaming',
                    title: 'Пишет ответ',
                    message: 'Модель передаёт текст ответа',
                };
                if (generationIndex >= 0) {
                    executionTrace[generationIndex] = {
                        ...executionTrace[generationIndex],
                        ...generationTrace,
                    };
                } else {
                    executionTrace.push(generationTrace);
                }
                updated[streamIndex] = {
                    ...updated[streamIndex],
                    text: `${updated[streamIndex].text || ''}${data.delta}`,
                    streaming: true,
                    executionTrace,
                };
            }

            dispatch(setMessages(updated));
        });
        dispatch(setIsWaiting(false));
        setProgress(0);
    }, [dispatch, isCurrentStreamDialog]);

    const handleAiStreamEnd = useCallback((data = {}) => {
        if (!data.streamId || !isCurrentStreamDialog(data)) return;

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            const streamIndex = currentMessages.findIndex((msg) => msg.streamId === data.streamId);
            if (streamIndex === -1) return;

            const updated = [...currentMessages];
            const streamStartedAt = Number(updated[streamIndex].streamStartedAt || 0);
            updated[streamIndex] = {
                ...updated[streamIndex],
                streaming: false,
                streamElapsedMs: streamStartedAt > 0 ? Date.now() - streamStartedAt : undefined,
                executionTrace: Array.isArray(updated[streamIndex].executionTrace)
                    ? updated[streamIndex].executionTrace.map((item) => (
                        item.status === 'running' || item.status === 'streaming'
                            ? {
                                ...item,
                                status: 'completed',
                                ...(item.stage === 'generation' ? { title: 'Ответ готов' } : {}),
                            }
                            : item
                    ))
                    : [],
            };
            dispatch(setMessages(updated));
        });
        dispatch(setIsWaiting(false));
        setProgress(0);
    }, [dispatch, isCurrentStreamDialog]);

    const handleAiStreamFallback = useCallback((data = {}) => {
        if (!data.streamId || !isCurrentStreamDialog(data)) return;

        console.warn('AI streaming fallback:', data.code, data.technicalMessage || data.message);
        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            const streamIndex = currentMessages.findIndex((msg) => msg.streamId === data.streamId);
            const fallbackText = data.message || 'Потоковый режим недоступен. Ожидаем полный ответ…';

            if (streamIndex === -1) {
                dispatch(setMessages([...currentMessages, {
                    id: `stream_${data.streamId}`,
                    streamId: data.streamId,
                    text: fallbackText,
                    sender: 'BotTax',
                    dialog_id: data.dialog_id ?? data.dialogId,
                    dialogId: data.dialogId ?? data.dialog_id,
                    type: 'system',
                    streaming: true,
                    streamFallback: true,
                }]));
                return;
            }

            const updated = [...currentMessages];
            updated[streamIndex] = {
                ...updated[streamIndex],
                text: fallbackText,
                type: 'system',
                streaming: true,
                streamFallback: true,
            };
            dispatch(setMessages(updated));
        });
    }, [dispatch, isCurrentStreamDialog]);

    const handleAiStreamError = useCallback((data = {}) => {
        if (!data.streamId || !isCurrentStreamDialog(data)) return;

        dispatch((dispatch, getState) => {
            const currentMessages = selectMessages(getState());
            const streamIndex = currentMessages.findIndex((msg) => msg.streamId === data.streamId);
            const errorText = data.message || 'Не удалось получить ответ локальной модели';

            if (streamIndex === -1) {
                dispatch(setMessages([...currentMessages, {
                    id: `stream_${data.streamId}`,
                    streamId: data.streamId,
                    text: errorText,
                    sender: 'BotTax',
                    dialog_id: data.dialog_id ?? data.dialogId,
                    dialogId: data.dialogId ?? data.dialog_id,
                    type: 'system',
                    streaming: false,
                    streamError: true,
                }]));
                return;
            }

            const updated = [...currentMessages];
            const partialText = String(updated[streamIndex].text || '').trim();
            updated[streamIndex] = {
                ...updated[streamIndex],
                text: partialText ? `${partialText}\n\n${errorText}` : errorText,
                streaming: false,
                streamError: true,
            };
            dispatch(setMessages(updated));
        });
        dispatch(setIsWaiting(false));
        setProgress(0);
    }, [dispatch, isCurrentStreamDialog]);
    // const handleSocket = (newMessage) => {
    //     if (parseInt(newMessage.dialogId) !== parseInt(dialogIdRef.current) &&
    //         parseInt(newMessage.dialog_id) !== parseInt(dialogIdRef.current)) {
    //         return;
    //     }

    //     reloadDialogs();

    //     dispatch((dispatch, getState) => {
    //         const currentMessages = selectMessages(getState());

    //         // Проверяем, не является ли это наше собственное сообщение (optimistic update)
    //         // Если sender === userEmail и сообщение уже есть (pending), заменяем его
    //         const existingIndex = currentMessages.findIndex(
    //             msg => msg.pending && msg.text === newMessage.text && msg.sender === 'me'
    //         );

    //         if (existingIndex !== -1) {
    //             // Заменяем optimistic сообщение на реальное с сервера
    //             const updated = [...currentMessages];
    //             updated[existingIndex] = { ...newMessage, sender: 'me' };
    //             dispatch(setMessages(updated));
    //         } else {
    //             // Новое сообщение (от сервера или BotTax)
    //             dispatch(setMessages([...currentMessages, newMessage]));
    //         }
    //     });

    //     if (newMessage.sender === 'system' || newMessage.sender === 'BotTax') {
    //         dispatch(setIsWaiting(false));
    //         setProgress(0);
    //         dispatch(setRatingMessageId(newMessage.id));

    //         if (chatType === 'docs_edit') {
    //             if (Array.isArray(newMessage.editedFiles) && newMessage.editedFiles.length > 0) {
    //                 setDocsEditStatus('done');
    //             } else {
    //                 setDocsEditStatus('editing');
    //                 // Socket payload for docs_edit may omit editedFiles metadata.
    //                 // Refresh from API so DocumentEditCard is available without page reload.
    //                 fetchMessages(dialogIdRef.current);
    //             }
    //         }
    //     }
    // };

    const handleSocketProgress = (data) => {
        const progressDialogId = data.dialogId;
        const get_progress = data.progress;
        //console.log('dialogId:', progressDialogId);
        //console.log('progress:', get_progress);

        // if (get_progress > progress) {
        //     setProgress(get_progress);
        // }    
        setProgress((prevProgress) => (get_progress > prevProgress ? get_progress : prevProgress));
    };

    const fetchUserData = async () => {
        try {
            // Получаем данные пользователя
            if (!userEmail) return
            const response = await profilApi.fetchUserData(userEmail, userId);
            //console.log('fetchUserData', response.data)
            // Устанавливаем данные о балансе и привязке карты
            if (response.data) {

                // const { subscriptionType, test, testall, isAudioAssistant } = response.data;
                // setIsTest(test)

                // if (subscriptionType) {
                //     setIsSubscription(true)
                // } else {
                //     setIsSubscription(false)
                //     dispatch(setIsStart(!testall))
                // }

                const { subscriptionType, isAudioAssistant } = response.data;
                const normalizedSubscriptionType = String(subscriptionType || '').toLowerCase();
                const isTestPlan = normalizedSubscriptionType === 'test';
                let hasAccess = Boolean(subscriptionType);

                if (!subscriptionType || isTestPlan) {
                    try {
                        const usageRes = await profilApi.getTestLimit(userId, userEmail);
                        const usage = usageRes?.data || {};
                        const isTestSubscription = Boolean(usage.isTestSubscription);
                        const allowed = Boolean(usage.allowed);

                        setTestLimitState({
                            isTestSubscription,
                            allowed,
                            reason: usage.reason || null,
                            message: usage.message || null,
                            used: Number(usage.used || 0),
                            remaining: Number(usage.remaining || 0),
                            limit: Number(usage.limit || 5),
                        });

                        if (isTestSubscription && allowed) {
                            hasAccess = true;
                        } else if (isTestSubscription && !allowed) {
                            hasAccess = false;
                        }
                    } catch (limitError) {
                        console.error('Ошибка получения test-limit:', limitError);
                        if (isTestPlan) {
                            setTestLimitState((prev) => ({
                                ...prev,
                                isTestSubscription: true,
                            }));
                        }
                    }
                }

                setIsSubscription(hasAccess)

                if (hasAccess && isAudioAssistant) {
                    setIsVoiceAssistant(true)
                }
            }
        } catch (error) {
            console.error('Ошибка при получении данных пользователя', error);
        }
    };



    async function fetchVoiceUsage() {
        try {

            //console.log("user Email for usage", userEmail)
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/voice/usage`,
                {
                    headers: {
                        "X-User-Email": userEmail,
                    },
                }
            );

            if (!res.ok) return;

            const data = await res.json();
            setVoiceUsage(data);
        } catch (err) {
            console.error("fetchVoiceUsage error", err);
        }
    }


    const handleChange = (key) => (e) => {
        setForm((prev) => ({
            ...prev,
            [key]: e.target.value,
        }));
    };

    const handleAdvanceReportChange = (key) => (e) => {
        setAdvanceReportForm((prev) => ({
            ...prev,
            [key]: e.target.value,
        }));
        setAdvanceReportSaved(false);
    };




    useEffect(() => {
        fetchUserData()
    }, []);

    // Load saved advance report data when switching to advance_report
    useEffect(() => {
        if (chatType !== 'advance_report' || !userId) return;
        (async () => {
            try {
                const res = await advancedDataApi.getAdvanceReportDataByUserId(userId);
                const d = res.data?.data;
                if (d && d.id) {
                    setAdvanceReportForm({
                        organizationName: d.organizationName || '',
                        headPosition: d.headPosition || '',
                        headFullName: d.headFullName || '',
                        accountablePerson: d.accountablePerson || '',
                        accountablePersonPosition: d.accountablePersonPosition || '',
                        chiefAccountantFullName: d.chiefAccountantFullName || '',
                        accountantFullName: d.accountantFullName || '',
                        cashierFullName: d.cashierFullName || '',
                    });
                    setAdvanceReportSaved(true);
                }
            } catch (e) {
                // 404 = no data yet, that's fine
                if (e?.response?.status !== 404) console.error('load advance report data', e);
            }
        })();
    }, [chatType, userId]);


    // useEffect(() => {
    //     fetchVoiceUsage();
    // }, []);


    useEffect(() => {
        if (!isVoiceActive) return;

        fetchVoiceUsage(); // сразу

        const interval = setInterval(() => {
            fetchVoiceUsage();
        }, 60_000); // раз в минуту

        return () => clearInterval(interval);
    }, [isVoiceActive]);

    function formatMinutes(ms) {
        return Math.max(Math.ceil(ms / 60000), 0);
    }


    // useEffect(() => {
    //     if (voiceUsage.warn30 && !warned30Ref.current) {
    //         showToast("Осталось 30 минут голосового общения");
    //         warned30Ref.current = true;
    //     }
    // }, [voiceUsage.warn30]);

    // useEffect(() => {
    //     if (voiceUsage.warn5 && !warned5Ref.current) {
    //         showToast("Осталось 5 минут! Голос скоро отключится");
    //         warned5Ref.current = true;
    //     }
    // }, [voiceUsage.warn5]);

    useEffect(() => {
        if (voiceUsage.expired) {
            showToast("Лимит голосового ассистента исчерпан");
            setIsVoiceActive(false); // UI
            // stopRelay() вызывается внутри VoiceAgent по событию
        }
    }, [voiceUsage.expired]);


    useEffect(() => {
        warned30Ref.current = false;
        warned5Ref.current = false;
    }, [voiceUsage.limitMs]);









    useEffect(() => {
        if (progress > 0 && progress < 90) {
            const interval = setInterval(() => {
                setProgress((prev) => (prev < 90 ? prev + 1 : prev));
            }, 1000); // Каждую секунду +1

            return () => clearInterval(interval);
        }
    }, [progress]);


    // useEffect(() => {
    //     socket.on('newMessage', handleSocket);
    //     return () => {
    //         socket.removeAllListeners('newMessage');
    //     };
    // }, []);
    useEffect(() => {
        if (!socket) return;

        const onNewMessage = (newMessage) => {
            handleSocket(newMessage);
        };

        socket.on('newMessage', onNewMessage);

        return () => {
            socket.off('newMessage', onNewMessage);
        };
    }, [socket, chatType, dispatch]);

    useEffect(() => {
        if (!socket) return;

        socket.on('aiStreamStart', handleAiStreamStart);
        socket.on('aiStreamTrace', handleAiStreamTrace);
        socket.on('aiStreamDelta', handleAiStreamDelta);
        socket.on('aiStreamEnd', handleAiStreamEnd);
        socket.on('aiStreamFallback', handleAiStreamFallback);
        socket.on('aiStreamError', handleAiStreamError);

        return () => {
            socket.off('aiStreamStart', handleAiStreamStart);
            socket.off('aiStreamTrace', handleAiStreamTrace);
            socket.off('aiStreamDelta', handleAiStreamDelta);
            socket.off('aiStreamEnd', handleAiStreamEnd);
            socket.off('aiStreamFallback', handleAiStreamFallback);
            socket.off('aiStreamError', handleAiStreamError);
        };
    }, [
        socket,
        handleAiStreamStart,
        handleAiStreamTrace,
        handleAiStreamDelta,
        handleAiStreamEnd,
        handleAiStreamFallback,
        handleAiStreamError,
    ]);


    useEffect(() => {
        if (!socket) return;

        socket.on('progress', handleSocketProgress);

        return () => {
            socket.off('progress', handleSocketProgress);
        };
    }, [socket]);


    useEffect(() => {
        if (!socket) return;

        const onError = (error) => {
            console.error('Socket error:', error);

            if (error?.error === 'DEVICE_LIMIT') {
                setShowDeviceLimit(true);
                // socket.disconnect();
                return;
            }

            alert(error.message || 'Ошибка соединения');
        };

        socket.on('error', onError);

        return () => {
            socket.off('error', onError);
        };
    }, [socket]);




    useEffect(() => {
        // //console.log('useEffect userEmail', userEmail)
        if (!userEmail) navigate('/login');
        if (isBindPay) handlePaymentSuccess();
        fetchDialogs();
        dispatch(setMode('chat'))
    }, []);

    const canRateLastMessage = async (messageId) => {
        try {
            const res = await chatApi.canRateLastMessage(userId, messageId);
            // //console.log(userId, messageId);
            // //console.log('resdata', res.data)
            return res.data.result;
        } catch (error) {
            console.error('error occured while rating last messasge', error)
            return false;
        }
    }

    useEffect(() => {
        setLoading(false)
        const checkLastMessage = async () => {
            // //console.log('mesmfemfesmfsmefs', messages)
            if (messages.length > 0) {
                const lastMessage = messages[messages.length - 1];
                // //console.log('checkLastMessage', lastMessage)


                if (lastMessage.type === 'system') {
                    // dispatch(setIsWaiting(false));
                    // //console.log('system message')
                }
                else if (lastMessage.sender === 'BotTax') {
                    try {
                        const res = await canRateLastMessage(lastMessage.id);
                        // //console.log('res', res);
                        if (res) {
                            dispatch(setRatingMessageId(lastMessage.id))
                        } else {
                            dispatch(setRatingMessageId(null))
                        }
                    } catch (error) {
                        console.error('Error while checking last message:', error);
                        dispatch(setRatingMessageId(null))
                    } finally {
                        // dispatch(setIsWaiting(false));
                    }
                }
                else {
                    dispatch(setRatingMessageId(null))
                    // dispatch(setIsWaiting(false)); //todo
                }
            }
            else setIsAnalysisComplete(false);
        };

        checkLastMessage();
    }, [messages]);

    useEffect(() => {

        clearSelectedFiles();
        setDocsEditStatus('idle');
    }, [selectedSubOption, dialogId, clearSelectedFiles]);

    // useEffect(() => {
    //     if (dialogId) {
    //         fetchMessages();
    //     }
    // }, [])

    useEffect(() => {
        // fetchMessages();
        // //console.log('useEffect scroll')
        const messagesContainer = document.querySelector('.messages');
        if (messagesContainer) {
            //console.log('messagesContainer.scrollHeight', messagesContainer.scrollHeight)
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }, [messages, loading]);


    useEffect(() => {
        // //console.log('dialogId', dialogId)
        dispatch(setIsWaiting(false))
    }, [dialogId]);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Сбрасываем высоту
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Устанавливаем новую высоту
        }
    }, [input]);


    if (!auth) {
        return (
            <div className='container mt-4'>
                <h3>{message}</h3>
                <button className='btn btn-primary' onClick={() => navigate('/login')}>Go to Login</button>
            </div>
        );
    }

    const isTestUser = Boolean(testLimitState?.isTestSubscription);
    const testLimit = Math.max(Number(testLimitState?.limit || 0), 0);
    const testUsed = Math.max(Number(testLimitState?.used || 0), 0);
    const testRemaining = Math.max(Number(testLimitState?.remaining || 0), 0);
    const testUsagePercent = testLimit > 0
        ? Math.min(100, Math.round((testUsed / testLimit) * 100))
        : 0;

    const renderTestLimitBanner = () => {
        if (!isTestUser) return null;

        const toneClass = !testLimitState?.allowed || testRemaining <= 0
            ? 'danger'
            : testRemaining <= 1
                ? 'warn'
                : 'ok';

        return (
            <div className={`test-limit-banner ${toneClass}`}>
                <div className="test-limit-head">
                    <span className="test-limit-title">Тестовая попытка</span>
                    <span className="test-limit-count">Осталось: {testRemaining} из {testLimit || 0}</span>
                </div>
                <div
                    className="test-limit-track"
                    role="progressbar"
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={testUsagePercent}
                >
                    <div className="test-limit-fill" style={{ width: `${testUsagePercent}%` }} />
                </div>
                {testLimitState?.message && !testLimitState?.allowed && (
                    <div className="test-limit-note">{testLimitState.message}</div>
                )}
            </div>
        );
    };

    const renderMessageInput = () => {
        if (['quick', 'quick_fin', 'quick_all',
            'docs_edit',
            'tax_agent_reply', 'accountant_agent_reply', 'law_claim_work',
            'law_contract_creation', 'law_corporate_docs_letters', 'law_posts_articles', 'law_agent_reply'].includes(chatType)) {
            return (
                <div className="input-container">
                    {/* отображение выбранных файлов */}
                    {files.length > 0 && (
                        <div className="file-list">
                            {files.map((file, index) => (
                                <div key={index} className="file-info">
                                    <span>{file.name}</span>
                                    {/* <button
                            className="remove-file"
                            onClick={() => handleRemoveFile(index)}
                            >
                            ❌
                            </button> */}
                                    <RxCross2
                                        className="remove-file"
                                        onClick={() => handleRemoveFile(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    <div className='input-plane'>
                        {/* панель с плюсиком */}
                        <AddPanel onAddFile={() => document.getElementById("file-upload")?.click()}
                            data-tooltip-id="custom-tooltip"
                            data-tooltip-content="Добавляйте файлы и многое другое"
                            data-tooltip-place="top"
                        />

                        {/* скрытый input для загрузки файлов */}
                        <input
                            ref={fileInputRef}
                            id="file-upload"
                            type="file"
                            multiple
                            accept={chatType === 'docs_edit' ? '.docx,.xlsx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : undefined}
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />

                        {/* поле ввода текста */}
                        <textarea
                            ref={textareaRef}
                            type="text"
                            value={input}
                            disabled={isVoiceActive}
                            placeholder={isVoiceActive ? "Говорите…" : chatType === 'docs_edit' ? "Опишите, что изменить в документе..." : "Напишите сообщение..."}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            style={{
                                width: "100%",
                                minHeight: "40px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                resize: "none",
                                padding: "0",
                            }}
                            className="text-area"
                        />
                        {/* {input.trim().length === 0 ? (
                            <VoiceAgent textareaRef={textareaRef} />
                            ) : (
                            // <button
                                // style={
                                // disableSendButton
                                //     ? {
                                //         backgroundColor: "#ccc",
                                //         cursor: "not-allowed",
                                //         opacity: 0.6,
                                //     }
                                //     : {}
                                // }
                                // disabled={disableSendButton}
                                // onClick={handleSendMessage}
                            // >
                            //     Отправить
                            // </button>
                            <BsArrowUpCircle  
                                style={
                                disableSendButton
                                    ? {
                                        backgroundColor: "#ccc",
                                        cursor: "not-allowed",
                                        opacity: 0.6,
                                    }
                                    : {}
                                }
                                disabled={disableSendButton}
                                onClick={handleSendMessage}
                                className='send-button'
                            
                            />
                            )} */}

                        {/* {!isHelped ? (
                                    isVoiceAssiatant === true ? (
                                        <VoiceAgent textareaRef={textareaRef} 
                                        userEmail={userEmail}
                                        setIsHelped={setIsHelped}
                                        data-tooltip-id="custom-tooltip"
                                        data-tooltip-content="Голосовой Ассистент"
                                        data-tooltip-place="top"
                                        
                                        />
                                    ) : (
                                        <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                        data-tooltip-id="custom-tooltip"
                                        data-tooltip-content="отправить сообщение"
                                        data-tooltip-place="top"
                                    />
                                    )
                                ) : (
                                    <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                    />
                                )} */}

                        {/* Голосовой ассистент */}
                        {canUseVoice && (
                            <VoiceAgent
                                textareaRef={textareaRef}
                                userEmail={userEmail}
                                onStart={() => setIsVoiceActive(true)}
                                onStop={() => setIsVoiceActive(false)}
                                topic={chatType}
                                forceStop={voiceUsage.expired}
                            />
                        )}

                        {/* Кнопка микрофона для голосового ввода */}
                        {!isVoiceActive && !isWaiting && (
                            <div
                                onClick={toggleSpeechRecording}
                                className={`mic-button ${isRecordingSpeech ? 'recording' : ''}`}
                                data-tooltip-id="custom-tooltip"
                                data-tooltip-content={isRecordingSpeech ? 'Остановить запись' : 'Голосовой ввод'}
                                data-tooltip-place="top"
                            >
                                {isRecordingSpeech ? <BsMicFill /> : <BsMic />}
                            </div>
                        )}

                        {/* Кнопка отправки - показываем когда есть текст или когда голосовой НЕ активен */}
                        {(showSendButton || !canUseVoice) && (
                            <BsArrowUpCircle
                                disabled={disableSendButton}
                                onClick={handleSendMessage}
                                className="send-button"
                            />
                        )}




                    </div>


                </div>

            );
        }

        if (chatType === 'contractAnalysis_all' || chatType === 'taxRisksAnalysis') {
            if (!isAnalysisComplete) {
                return (
                    <div className="input-container">
                        {/* отображение выбранных файлов */}
                        {files.length > 0 && (
                            <div className="file-list">
                                {files.map((file, index) => (
                                    <div key={index} className="file-info">
                                        <span>{file.name}</span>
                                        <RxCross2
                                            className="remove-file"
                                            onClick={() => handleRemoveFile(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                        {/* <div className="file-upload">
                            {files.length === 0 ? (
                                <div className="file-upload-container">
                                    <label htmlFor="file-upload" className="file-upload-icon">
                                        <img
                                            src="https://img.icons8.com/?size=100&id=11321&format=png&color=000000"
                                            alt="Скрепка"
                                            className='clip-icon'
                                        />
                                        <span>Вы можете прикрепить файл</span>
                                    </label>
                                    <input
                                        id="file-upload"
                                        type="file"
                                        accept=".doc, .docx, .pdf"
                                        onChange={handleFileChange}
                                        multiple
                                        style={{ display: 'none' }}
                                    />
                                </div>
                            ) : (
                                <div className="file-list">
                                    {files.map((file, index) => (
                                        <div key={index} className="file-info">
                                            <span>{file.name}</span>
                                            <button className="remove-file" onClick={() => handleRemoveFile(index)}>
                                                ❌
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div> */}

                        <div className='input-plane'>
                            {/* панель с плюсиком */}
                            <AddPanel onAddFile={() => document.getElementById("file-upload")?.click()} />

                            {/* скрытый input для загрузки файлов */}
                            <input
                                ref={fileInputRef}
                                id="file-upload"
                                type="file"
                                multiple
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />

                            <BsArrowUpCircle
                                style={
                                    disableSendButton
                                        ? {
                                            backgroundColor: "#ccc",
                                            opacity: 0.6,
                                        }
                                        : {}
                                }
                                disabled={disableSendButton}
                                onClick={handleSendMessage}
                                className='send-button'
                            />
                            {/* <button
                                style={disableSendButton ? {
                                    backgroundColor: '#ccc',
                                    cursor: 'not-allowed',
                                    opacity: 0.6
                                } : {}}
                                disabled={disableSendButton}
                                onClick={handleSendMessage}>
                                Отправить
                            </button> */}

                        </div>
                    </div>
                );
            }

            return (
                <div className="input-container">
                    {/* отображение выбранных файлов */}
                    {files.length > 0 && (
                        <div className="file-list">
                            {files.map((file, index) => (
                                <div key={index} className="file-info">
                                    <span>{file.name}</span>
                                    <RxCross2
                                        className="remove-file"
                                        onClick={() => handleRemoveFile(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    <div className='input-plane'>
                        {/* панель с плюсиком */}
                        <AddPanel onAddFile={() => document.getElementById("file-upload")?.click()} />

                        {/* скрытый input для загрузки файлов */}
                        <input
                            ref={fileInputRef}
                            id="file-upload"
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                        <textarea
                            ref={textareaRef}
                            type="text"
                            value={input}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            disabled={isVoiceActive}
                            placeholder={isVoiceActive ? "Говорите…" : "Напишите сообщение..."}
                            className='text-area'
                        />
                        {/* <button
                            style={disableSendButton ? {
                                backgroundColor: '#ccc',
                                cursor: 'not-allowed',
                                opacity: 0.6
                            } : {}}
                            disabled={disableSendButton}
                            onClick={handleSendMessage}>
                            Отправить
                        </button> */}
                        {/* {!isHelped ? (
                                    isVoiceAssiatant === true ? (
                                        <VoiceAgent textareaRef={textareaRef}
                                        setIsHelped={setIsHelped}
                                        userEmail={userEmail} />
                                    ) : (
                                        <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                    />
                                    )
                                ) : (
                                    <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                    />
                                )} */}

                        {/* Голосовой ассистент */}
                        {canUseVoice && (
                            <VoiceAgent
                                textareaRef={textareaRef}
                                userEmail={userEmail}
                                onStart={() => setIsVoiceActive(true)}
                                onStop={() => setIsVoiceActive(false)}
                                topic={chatType}
                                forceStop={voiceUsage.expired}
                            />
                        )}

                        {/* Кнопка отправки */}
                        {(showSendButton || !canUseVoice) && (
                            <BsArrowUpCircle
                                disabled={disableSendButton}
                                onClick={handleSendMessage}
                                className="send-button"
                            />
                        )}
                    </div>
                    {/* <div className="file-upload">
                        {files.length === 0 ? (
                            <div className="file-upload-container">
                                <label htmlFor="file-upload" className="file-upload-icon">
                                    <img
                                        src="https://img.icons8.com/?size=100&id=11321&format=png&color=000000"
                                        alt="Скрепка"
                                        className='clip-icon'
                                    />
                                    <span>Вы можете прикрепить файл</span>
                                </label>
                                <input
                                    ref={fileInputRef}
                                    id="file-upload"
                                    type="file"
                                    accept=".doc, .docx, .pdf"
                                    onChange={handleFileChange}
                                    multiple
                                    style={{ display: 'none' }}
                                />
                            </div>
                        ) : (
                            <div className="file-list">
                                {files.map((file, index) => (
                                    <div key={index} className="file-info">
                                        <span>{file.name}</span>
                                        <button className="remove-file" onClick={() => handleRemoveFile(index)}>
                                            ❌
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div> */}
                </div>
            );
        }

        if (chatType === 'advance_report') {
            const advanceFields = [
                ['organizationName', 'Наименование организации'],
                ['headPosition', 'Должность руководителя'],
                ['headFullName', 'ФИО руководителя'],
                ['accountablePerson', 'Подотчетное лицо(фамилия,инициалы)'],
                ['accountablePersonPosition', 'Должность подотчетного лица'],
                ['chiefAccountantFullName', 'Главный бухгалтер(ФИО)'],
                ['accountantFullName', 'Бухгалтер(ФИО)'],
                ['cashierFullName', 'Кассир(ФИО)'],
            ];

            return (
                <div className="input-container advance-report-container">
                    <div className="advance-report-form">
                        {advanceFields.map(([key, label]) => (
                            <div className="advance-report-field" key={key}>
                                <label className="advance-report-label">{label}</label>
                                <input
                                    type="text"
                                    className="advance-report-input"
                                    value={advanceReportForm[key]}
                                    onChange={handleAdvanceReportChange(key)}
                                    placeholder={label}
                                />
                            </div>
                        ))}
                    </div>

                    {/* File upload area */}
                    {files.length > 0 && (
                        <div className="file-list">
                            {files.map((file, index) => (
                                <div key={index} className="file-info">
                                    <span>{file.name}</span>
                                    <RxCross2
                                        className="remove-file"
                                        onClick={() => handleRemoveFile(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="input-plane">
                        <AddPanel onAddFile={() => document.getElementById("file-upload-ar")?.click()} />
                        <input
                            ref={fileInputRef}
                            id="file-upload-ar"
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />

                        {advanceReportSaved && (
                            <span className="advance-report-saved-badge">Реквизиты сохранены</span>
                        )}

                        <BsArrowUpCircle
                            disabled={files.length === 0 && Object.values(advanceReportForm).every(v => !v.trim())}
                            onClick={handleSendMessage}
                            className="send-button"
                        />
                    </div>
                </div>
            );
        }

        if (chatType === 'okof_identifyer') {
            return (
                <div className="input-container">
                    <div className='input-plane'>
                        <textarea
                            value={form.name}
                            onChange={handleChange('name')}
                            placeholder="Напишите наименование ОС..."
                            className='text-area'
                            style={{
                                width: "200px",
                                minHeight: "40px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                resize: "none",
                                padding: "0",
                            }}
                        />

                        <textarea
                            value={form.description}
                            onChange={handleChange('description')}
                            placeholder="Напишите описание ОС..."
                            className='text-area'
                            style={{
                                width: "200px",
                                minHeight: "40px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                resize: "none",
                                padding: "0",
                            }}
                        />


                        <BsArrowUpCircle
                            disabled={disableSendButton}
                            onClick={handleSendMessage}
                            className="send-button"
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="input-container">
                <textarea
                    ref={textareaRef}
                    type="text"
                    value={input}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    disabled={isVoiceActive}
                    placeholder={isVoiceActive ? "Говорите…" : "Напишите сообщение..."}
                    className='text-area'
                />
                {/* {!isHelped ? (
                                    isVoiceAssiatant === true ? (
                                        <VoiceAgent textareaRef={textareaRef} 
                                        setIsHelped={setIsHelped}
                                        userEmail={userEmail}/>
                                    ) : (
                                        <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                    />
                                    )
                                ) : (
                                    <BsArrowUpCircle  
                                        style={
                                            disableSendButton
                                                ? {
                                                    backgroundColor: "#ccc",
                                                    cursor: "not-allowed",
                                                    opacity: 0.6,
                                                }
                                                : {}
                                        }
                                        disabled={disableSendButton}
                                        onClick={handleSendMessage}
                                        className='send-button'
                                    />
                                )} */}

                {/* Голосовой ассистент */}
                {canUseVoice && (
                    <VoiceAgent
                        textareaRef={textareaRef}
                        userEmail={userEmail}
                        onStart={() => setIsVoiceActive(true)}
                        onStop={() => setIsVoiceActive(false)}
                        topic={chatType}
                        forceStop={voiceUsage.expired}
                    />
                )}

                {/* Кнопка отправки */}
                {(showSendButton || !canUseVoice) && (
                    <BsArrowUpCircle
                        disabled={disableSendButton}
                        onClick={handleSendMessage}
                        className="send-button"
                    />
                )}
                {/* <button
                    style={disableSendButton ? {
                        backgroundColor: '#ccc',
                        cursor: 'not-allowed',
                        opacity: 0.6
                    } : {}}
                    disabled={disableSendButton} onClick={handleSendMessage}>Отправить</button> */}
            </div>
        );
    };

    const topic = (() => {
        switch (selectedSubOption) {
            // бухгалтерская тематика
            case 'quick_fin':
            case 'accountant_agent_reply':
                return 'бухгалтерской тематике';

            // юридическая тематика
            case 'quick_all':
            case 'docs_edit':
            case 'advance_report':
            case 'contractAnalysis_all':
            case 'law_claim_work':
            case 'law_contract_creation':
            case 'law_corporate_docs_letters':
            case 'law_posts_articles':
            case 'law_agent_reply':
                return 'юридической тематике';

            // налоговая тематика
            case 'quick':
            case 'taxRisksAnalysis':
            case 'actualPracticeM':
            case 'actualPractice':
            case 'letterMfFns':
            case 'tax_agent_reply':
                return 'налоговой тематике';

            default:
                return 'налоговой тематике';
        }
    })();

    const waitingText = (chatType === 'docs_edit' || chatType === 'advance_report')
        ? (docsEditStatus === 'uploading'
            ? 'Загружаем файл...'
            : docsEditStatus === 'editing'
                ? 'Редактируем документ...'
                : docsEditStatus === 'error'
                    ? 'Ошибка'
                    : 'Ожидание...')
        : `Ожидание... ${progress} %`;


    return (
        <>
            <div className='chat-app'>
                {renderTestLimitBanner()}
                {(mode === 'dialogs' || isDesktop) &&
                    <Sidebar
                        onDialogSelect={handleSelectDialog}
                        selectedDialogId={dialogId}
                        fetchDialogs={fetchDialogs}
                        isSubscription={isSubscription}
                        dialogId={dialogId}
                    />

                }

                {(mode === 'chat' || isDesktop) && !loading &&
                    <ChatContainer
                        messages={messages}
                        setChatType={setChatType}
                        // selectedSubOption={selectedSubOption}
                        topic={topic}
                        handleClickToDialogs={handleClickToDialogs}
                        // backIcon={backIcon}
                        // ratingMessageId={ratingMessageId}
                        handleRating={handleRating}
                        // isAwaitingRole={isAwaitingRole}
                        isAwaitingDetails={isAwaitingDetails}
                        isAwaitingQuestion={isAwaitingQuestion}
                        isAwaitingRateComment={isAwaitingRateComment}
                        role={role}
                        handleRoleSelection={handleRoleSelection}
                        handleSkipToDialog={handleSkipToDialog}
                        handleSkipRateComment={handleSkipRateComment}
                        isWaiting={isWaiting}
                        renderMessageInput={renderMessageInput}
                        formatText={formatText}
                        progress={progress}
                        waitingText={waitingText}
                        showProgressBar={chatType !== 'docs_edit' && chatType !== 'advance_report'}
                        isSubscription={isSubscription}
                        // test={isTest}
                        userId={userId}
                    />
                }
                {
                    loading && <div className="loading">Загрузка сообщений...</div>
                }

            </div>

            {showDeviceLimit && (
                <DeviceLimitModal
                    onClose={() => setShowDeviceLimit(false)}
                    onResolved={async () => {
                        setShowDeviceLimit(false);
                        try { socket.connect(); } catch (e) { console.warn('socket reconnect failed', e); }
                    }}
                />
            )}

            {toast && (
                <div className={`voice-toast ${toast.type}`}>
                    {toast.message}
                </div>
            )}

        </>
    );

};

export default ChatApp;
